import { parseRichLabelText } from "../../../../../../engine/modules/ui/richLabelText.js";

function getPlainLabelLineText(line) {
  return parseRichLabelText(line).map((segment) => segment.text).join("");
}

export { getPlainLabelLineText };
